import ProductIndex from '@/components/product/Index.vue'

import PlanIndex from '@/components/product/plan/Index.vue'
// import PlanPlant from '@/components/product/plan/plant.vue'
import PlanLabor from '@/components/product/plan/Labor.vue'
import PlanInputs from '@/components/product/plan/Inputs.vue'
import PlanHarvest from '@/components/product/plan/Harvest.vue'
import PlanList from "@/components/product/plan/PlanList";
import Task from '@/components/product/task/executePlant.vue'
import OperateIndex from '@/components/product/operate/Index.vue'
import OperateFertilizer from '@/components/product/operate/Fertilizer.vue'
import OperateEnvironment from '@/components/product/operate/Environment.vue'
import PlanDetail from "../components/product/plan/PlanDetail";

export default {
  path: 'product',
  component: ProductIndex,
  children: [
    /**
     * 生产计划
     */
    {
      path: 'plan',
      component: PlanIndex,
      children: [
        /**
         * 种植计划
         */
        {
          path: 'list',
          component: PlanList
        },
        {
          path: 'detail/:id',
          component: PlanDetail
        },
        /**
         * 用工计划
         */
        {
          path: 'labor',
          component: PlanLabor
        },
        /**
         * 投入计划
         */
        {
          path: 'inputs',
          component: PlanInputs
        },
        /**
         * 采摘计划
         */
        {
          path: 'harvest',
          component: PlanHarvest
        },
      ]
    },
    /**
     * 生产任务
     */
    {
      path: 'task',
      component: Task,
      children: [

        // /**
        //  * 生产任务
        //  */
        // {
        //   path: 'upload',
        //   component: Upload
        // },
        // /**
        //  *  任务执行
        //  */
        // {
        //   path: 'executePlant',
        //   component: executePlant
        // },
      ]
    },
    /**
     * 生产控制
     */
    {
      path: 'operate',
      component: OperateIndex,
      children: [
        /**
         * 水肥控制
         */
        {
          path: 'fertilizer',
          component: OperateFertilizer
        },
        /**
         *  环境控制
         */
        {
          path: 'environment',
          component: OperateEnvironment
        },
      ]
    }
  ]
}



// WEBPACK FOOTER //
// ./src/router/product.js